import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/_organization/organization-settings/roles-permissions/$roleUuid/"
)({
  component: RoleIndexRedirect,
})

function RoleIndexRedirect() {
  const { roleUuid } = Route.useParams()

  return (
    <Navigate
      to="/organization-settings/roles-permissions/$roleUuid/$tabKey"
      params={{ roleUuid, tabKey: "details" }}
    />
  )
}
